import React, {FunctionComponent, useState, useEffect} from 'react';
import {Button, Callout} from '@blueprintjs/core';

import {ReactComponent as PmLegacyIcon} from '../../assets/logo/pm-legacy-logo.svg';
import NewReportButton from '../../shared/components/NewReportButton';
import {isLegacyPmUser} from '../../shared/utils/auth';
import {useCurrentUser} from '../../shared/hooks';

type TileButtonProps = {};

export const TileButtons: FunctionComponent<TileButtonProps> = () => {
  const currentUser = useCurrentUser();
  const [isDismissedLegacyUsersCallout, setIsDismissedLegacyUsersCallout] =
    useState<boolean>(false);

  useEffect(() => {
    const dismissState = localStorage.getItem('LegacyUsersCalloutDismissed');
    if (dismissState === 'true') {
      setIsDismissedLegacyUsersCallout(true);
    }
  }, []);

  const handleDismiss = () => {
    // Save the dismiss state to localStorage
    localStorage.setItem('LegacyUsersCalloutDismissed', 'true');
    setIsDismissedLegacyUsersCallout(true);
  };

  return (
    <>
      <div className="home__content__new-report-button">
        <NewReportButton/>
      </div>
      {isLegacyPmUser(currentUser) && !isDismissedLegacyUsersCallout && (
        <Callout
          className="home__content__legacy-user-callout"
          title="Looking for PushMetrics v1?"
          icon={<PmLegacyIcon className="bp4-icon"/>}
          intent="warning"
        >
          Welcome to the new, upgraded PushMetrics. If you were looking for the
          old version (PushMetrics v1),{' '}
          <a href="https://app.pushmetrics.io">click here</a>.
          <Button minimal icon="cross" onClick={handleDismiss}/>
        </Callout>
      )}
    </>
  );
};
